import { inject, injectable } from "inversify";
import { ICriarWebserviceModel } from "../types";
import { WebserviceGateway } from "../ports/WebserviceGateway";
import {
  HttpStatusCode,
  IHttpResponse,
  type HttpClient
} from "@/core/services/protocols/types";
import { type IToastNotification } from "@/composables/shared/notification/types";
import { DITypes } from "@/core/@types/types";

@injectable()
export default class WebserviceGatewayAdapter implements WebserviceGateway {
  @inject(DITypes.FINANCAS_HTTP_CLIENT)
  private httpClient!: HttpClient;

  @inject(DITypes.NOTIFICATION)
  private notification!: IToastNotification<string>;

  async criarWebservice(
    model: ICriarWebserviceModel,
    onErrorDisplayed: boolean
  ): Promise<string | void> {
    const response = await this.httpClient?.post<IHttpResponse>({
      url: "/WebserviceAPI/Save/",
      body: {
        ...model
      }
    });

    if (response?.statusCode != HttpStatusCode.success) {
      return this.notification.showNotification(
        "Houve um erro ao conectar a sua conta! Por favor, tente novamente mais tarde.",
        {
          type: "error",
          timeout: 3000
        }
      );
    } else if ((response?.body as any).Error !== undefined) {
      return this.notification.showNotification((response?.body as any).Error, {
        type: "error",
        timeout: 10000
      });
    }

    //__vmo.UI.AtivacaoAutomacaoBancaria.UpdateScreenState(id);//verificar o porque desse updateScreenState//implementar futuramente
    //função atualizar as grids e funcionalidades em tela

    if (onErrorDisplayed) return;

    this.notification.showNotification("Conexão Realizada com Sucesso!", {
      type: "success",
      timeout: 3000
    });

    setTimeout(() => {
      window.location.reload();
    }, 3000);
  }
}
